import { createContext } from "react";
import type { Unsubscribe } from "nanoevents";

export type FormApi = {
  refresh: (
    params?: { resetForm?: boolean; revalidateData?: boolean } | undefined,
  ) => Promise<void>;
  onRefresh: (cb: () => void) => Unsubscribe;
  changeLanguage: (params: { lang: string; copy?: boolean }) => void;
  delete: () => void;
  hasUnsavedChanges: () => boolean;
  clearStorage: () => void;
};

export type ResourceFormApiContext = FormApi;

export const ResourceFormApiContext =
  createContext<ResourceFormApiContext | null>(null);
